import { Grid, makeStyles, Theme } from "@material-ui/core";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import React from "react";
import DetailsInfos from "../shared/RightSideComponents/components/DetailsInfos";
import SchedulingDetails from "../shared/RightSideComponents/components/SchedulingDetails";
import VehicleDetails from "../shared/RightSideComponents/components/VehicleDetails";

const useRecapStyles = makeStyles((theme: Theme) => ({
  container: {
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap-reverse",
    },
  },
}));
const Recap = () => {
  const { setStep, requestQuote } = React.useContext(NewRequestQuoteContext);
  const styles = useRecapStyles();
  React.useEffect(() => {
    setStep(3);
  });
  return (
    <div style={{ width: "100%" }}>
      <Grid container spacing={4} className={styles.container}>
        <Grid item xs={12}>
          <SchedulingDetails requestToDisplay={requestQuote} />
          <br />
          <DetailsInfos requestToDisplay={requestQuote} />
        </Grid>
        <Grid item xs={12}>
          <VehicleDetails requestToDisplay={requestQuote} />
        </Grid>
      </Grid>
    </div>
  );
};

export default Recap;
